export const siteSettings = {
  name: "Sky Horizon Markets",
  link: "https://skyhorizonmarkets.com",
  email: "support@skyhorizonmarkets.com",
  appLink: "https://app.skyhorizonmarkets.com",
};
